import React from "react";
import "./KanziMemorial.css";

const KanziMemorial = () => {
  return (
    <div className="kanzi-container">
      <h1 className="kanzi-header">Celebrating the Life of Kanzi</h1>
      <div className="kanzi-content">
        <p></p>
        <p>
          Quite suddenly, Kanzi (1980-2025) passed away on March 18<sup>th</sup>{" "}
          at the <i>Ape Initiative</i> Lab in Des Moines, IA. We view this as an
          irreparable loss for science and for humanity. In acquiring at an
          early age an astounding level of comprehension of spoken English as
          well as a very high command of arbitrary signs (called lexigrams)
          through which he could communicate with humans, bonobo Kanzi led the
          way in the redefinition of the human mind, the role of culture, the
          function of a symbolic environment. Kanzi learned to make stone tools
          and fire, he understood narratives and movies, he could produce art
          and make jokes. He was the object of several documentary movies and of
          hundreds of publications. For more than a decade now, Dr. Sue
          Savage-Rumbaugh, the experimental psychologist and primatologist who
          raised Kanzi and presented his achievements to the scientific
          community and the larger public as early as the 1990s, was unduly
          prevented from getting access to him and the rest of the group. Bonobo
          Hope International (BHI), legally the “co-owner” of Kanzi and of
          several other members of the family living in Des Moines, has been
          similarly set aside by the <i>Ape Initiative.</i> BHI laments Kanzi's
          passing.
        </p>
        <p>
          BHI deplores the long-term separation of the human and bonobo families
          whose lives once became enmeshed. BHI deeply regrets that Kanzi's
          unique intellectual and personal capabilities could not be shown to
          the outside world in their proper light since Savage-Rumbaugh's
          removal in 2013. Through the crude downsizing of Kanzi's cultural
          environment since that period, Kanzi's voice has largely been
          silenced, many years before his tragic death. But his legacy
          continues, as will be soon be seen in further publications,
          exhibitions, and other initiatives. Moreover, Kanzi's relatives Nyota
          and Teco, who also have access to a reality mediated by human culture
          and language, continue to have many things to teach us, as do the
          other bonobos in Des Moines and elsewhere.
        </p>

        <p>
          BHI is inviting all those who feel the pain of Kanzi's passing to ask
          for the restoration of a research trajectory that will focus on the
          dignity of the bonobo group. “Right now” (as Kanzi would often say
          with some sense of urgency) is the time for uniting and recreating the
          conditions of life and research that would be in phase with the
          cognitive potentiality and emotional needs of Nyota, Teco, and their
          friends and relatives. Dr. Savage-Rumbaugh should be given back access
          to the bonobo group. The language research should finally be restored
          in its full form. BHI wishes to lead that effort and help the Ape
          Initiative to reach that scholarly and moral goal.
        </p>
      </div>
    </div>
  );
};

export default KanziMemorial;
